import { Dialog, DialogContent, IconButton, Tab } from '@mui/material';
import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { TabList } from '@mui/lab';
import { useState } from 'react';
import TabContext from '@mui/lab/TabContext';
import { VideoManagerProps } from '../types/videos';
import { PanelVideo } from './video/PanelVideo';
import { PanelVideoSummary } from './video/PanelVideoSummary';
import Box from '@mui/material/Box';
import { PanelVideoWithTranscriptV2 } from './video/PanelVideoWithTranscriptV2';
import { VideoManagerState } from '../../store/videoManagerSlice';
import { useSelector } from 'react-redux';
import { RootState } from '../../index';
import { PanelVideoProperties } from './video/PanelVideoProperties';

const CloseBtnRoot = styled('div')`
    position: absolute;
    right: 8px;
    top: 5px;
    z-index: 2;
`;

const Root = styled('div')`
    position: relative;
`;

export const RHVideoPreview = ({
  open,
  handleClose,
  video,
}: {
  open: boolean,
  handleClose: () => void,
  video: VideoManagerProps;
}) => {
  const [tabValue, setTabValue] = useState('1');

  const { rhLang } = useSelector<RootState, VideoManagerState>((state) => state.videoManager);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={'lg'}>
      <Root>
        <CloseBtnRoot>
          <IconButton onClick={handleClose}>
            <CloseIcon/>
          </IconButton>
        </CloseBtnRoot>
        <DialogContent sx={{ p: 0 }}>
          <TabContext value={tabValue}>
            <TabList onChange={(_, newValue) => setTabValue(newValue)}
                     sx={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}
            >
              <Tab value="1" label="Video"/>
              <Tab value="2" label="Summary"/>
              {video.parent_media_id && <Tab value="3" label="Original"/>}
              <Tab value="4" label="Properties"/>
            </TabList>
          </TabContext>
          <Box sx={{
            minHeight: '660px'
          }}>
            {tabValue === '1' && (video.format === 'vertical' ? <PanelVideoWithTranscriptV2 availableLangs={rhLang} video={video}/> : <PanelVideo video={video}/>)}
            {tabValue === '2' && <PanelVideoSummary opusProps={{
              opus_title: video.opus_title,
              opus_description: video.opus_description,
              opus_clip_genre: video.opus_clip_genre,
              opus_hashtags: video.opus_hashtags,
            }} asa_compliant={video.asa_compliant} summary={video.summary}/>}
            {tabValue === '3' && <PanelVideo video={{
              ...video,
              format: 'horizontal',
              media_id: video.parent_media_id as string
            }}/>}
            {tabValue === '4' && (video.creator_logo_url &&
              video.creator_url && video.creator_name && typeof video.use_org_meta === 'boolean'
              && <PanelVideoProperties
              creatorUrl={video.creator_url}
              creatorLogoUrl={video.creator_logo_url}
              creatorName={video.creator_name}
              useOrgMetadata={video.use_org_meta}
            />)}
          </Box>

        </DialogContent>
      </Root>
    </Dialog>
  );
};
